import { render } from "./CadastrarAnalises.vue?vue&type=template&id=ee847796"
import script from "./CadastrarAnalises.vue?vue&type=script&lang=js"
export * from "./CadastrarAnalises.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__